import { InputText } from "primereact/inputtext";

import { Checkbox, Dropdown, FormField } from "@/ds";

import {
  MARCO_OPTIONS,
  RELACAO_OPTIONS,
  UNIDADE_OPTIONS,
  VALOR_MAX_LENGTH,
} from "./janela-bloco.constants";
import styles from "./janela-bloco.module.scss";
import type { JanelaBlocoViewModel } from "./types-janela-bloco";

export function JanelaBlocoView({
  titulo,
  checkboxLabel,
  ids,
  labels,
  values,
  valorError,
  valorInvalido,
  camposInvalidos,
  disabled,
  marcar,
  digitarValor,
  sairDoValor,
  escolherUnidade,
  escolherRelacao,
  escolherMarco,
}: JanelaBlocoViewModel) {
  return (
    <div className={styles.bloco} data-testid={ids.bloco}>
      <p className={styles.titulo}>{titulo}</p>

      <FormField.Root labelPosition="right" disabled={disabled}>
        <FormField.Label>{checkboxLabel}</FormField.Label>
        <FormField.Control>
          <Checkbox
            checked={values.marcado}
            onChange={(event) => marcar(Boolean(event.checked))}
            data-testid={ids.marcado}
          />
        </FormField.Control>
      </FormField.Root>

      {values.marcado ? null : (
        <FormField.Root error={valorError} className={styles.campo}>
          <FormField.Label visuallyHidden>{labels.valor}</FormField.Label>
          <div className={styles.linha} data-testid={ids.linha}>
            <FormField.Control>
              <InputText
                className={valorInvalido ? "p-invalid" : undefined}
                value={values.valor}
                inputMode="numeric"
                maxLength={VALOR_MAX_LENGTH}
                disabled={disabled}
                onChange={(event) => digitarValor(event.currentTarget.value)}
                onBlur={sairDoValor}
                data-testid={ids.valor}
              />
            </FormField.Control>

            <Dropdown
              className={styles.unidade}
              value={values.unidade}
              options={UNIDADE_OPTIONS}
              ariaLabel={labels.unidade}
              invalid={camposInvalidos}
              disabled={disabled}
              onChange={(event) => escolherUnidade(event.value)}
              data-testid={ids.unidade}
            />

            <Dropdown
              className={styles.relacao}
              value={values.relacao}
              options={RELACAO_OPTIONS}
              ariaLabel={labels.relacao}
              invalid={camposInvalidos}
              disabled={disabled}
              onChange={(event) => escolherRelacao(event.value)}
              data-testid={ids.relacao}
            />

            <Dropdown
              className={styles.marco}
              value={values.marco}
              options={MARCO_OPTIONS}
              ariaLabel={labels.marco}
              invalid={camposInvalidos}
              disabled={disabled}
              onChange={(event) => escolherMarco(event.value)}
              data-testid={ids.marco}
            />
          </div>
          <FormField.Error data-testid={ids.valorError} />
        </FormField.Root>
      )}
    </div>
  );
}
